// extracted by mini-css-extract-plugin
export default {"per_inf":"personal_inforamtion_per_inf__M2ej5"};